function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8118 10.195H17.4107C18.0792 10.195 18.6642 9.60999 18.6642 8.94147C18.6642 8.27295 18.0792 7.68799 17.4107 7.68799H11.8118C11.1433 7.68799 10.5583 8.27295 10.5583 8.94147C10.5583 9.60999 11.1433 10.195 11.8118 10.195Z",
  fill: "url(#paint30_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6781 12.8692C23.6781 12.2007 23.0932 11.6157 22.4246 11.6157H11.8118C11.1433 11.6157 10.5583 12.2007 10.5583 12.8692C10.5583 13.5377 11.1433 14.1227 11.8118 14.1227H22.4246C23.0932 14.1227 23.6781 13.5377 23.6781 12.8692Z",
  fill: "url(#paint31_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8118 15.2925C11.1433 15.2925 10.5583 15.8774 10.5583 16.546C10.5583 17.2145 11.1433 17.7994 11.8118 17.7994H20.8369C21.5054 17.7994 22.0904 17.2145 22.0904 16.546C22.0904 15.8774 21.5054 15.2925 20.8369 15.2925H11.8118Z",
  fill: "url(#paint32_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.4416 10.6129C29.1339 10.6129 29.6951 10.0517 29.6951 9.35944C29.6951 8.66716 29.1339 8.10596 28.4416 8.10596C27.7493 8.10596 27.1881 8.66716 27.1881 9.35944C27.1881 10.0517 27.7493 10.6129 28.4416 10.6129Z",
  fill: "url(#paint33_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5306 23.5655L28.8593 18.6351C29.5279 17.1309 29.9457 15.5432 30.1128 13.7883V13.454H30.0293C29.8621 12.9526 29.4443 12.5348 28.8593 12.5348C28.2744 12.5348 27.8565 12.9526 27.6894 13.454C27.6894 13.5376 27.6059 13.6212 27.6059 13.7883V13.8719C27.5223 15.2925 27.1045 16.7131 26.4359 17.9666C26.2688 18.3008 26.2688 18.6351 26.3524 18.9694L28.1072 24.0669L23.0098 22.312C22.6755 22.2284 22.3412 22.2284 22.007 22.3955C20.5028 23.1476 18.8315 23.649 17.0766 23.649C11.3942 23.649 6.63092 18.9694 6.54735 13.2869C6.46379 10.4457 7.63371 7.68802 9.63928 5.68245C11.6448 3.67688 14.2354 2.59053 17.0766 2.59053H17.2437C20.1685 2.67409 23.0097 3.92758 24.9318 6.18385L25.0153 6.26741H25.0989C25.3496 6.43454 25.6003 6.51811 25.851 6.51811C26.5195 6.51811 27.1045 5.93315 27.1045 5.26462C27.1045 5.18106 27.1045 5.01393 27.0209 4.93036H27.188L26.9373 4.67966C26.8538 4.51253 26.7702 4.42897 26.6031 4.26184L26.5195 4.17827C26.4359 4.09471 26.3524 4.01114 26.2688 3.92758C23.8454 1.50418 20.6699 0.0835655 17.2437 0C13.734 0 10.3914 1.33705 7.8844 3.76045C5.54457 6.10028 4.20752 9.27576 4.12396 12.6184C1.78413 14.4568 0.447077 17.2145 0.447077 20.1393C0.447077 21.4763 0.781339 22.8969 1.28273 24.0669L0.112814 27.4095C-0.137883 28.1616 0.0292469 28.9136 0.614205 29.415C0.948467 29.7493 1.44986 30 2.03482 30C2.28552 30 2.45265 30 2.70334 29.9164L6.04596 28.7465C7.29944 29.3315 8.63649 29.5822 10.0571 29.5822C13.0655 29.5822 15.8231 28.1616 17.6616 25.8217C19.4164 25.7382 21.1713 25.3203 22.7591 24.5682L27.6894 26.2396C28.5251 26.4903 29.4443 26.3231 30.0293 25.6546C30.6142 25.3203 30.7813 24.4011 30.5306 23.5655ZM6.71449 26.5738C6.38022 26.4067 6.04596 26.4067 5.7117 26.4902L2.78691 27.493L3.78969 24.5682C3.87326 24.234 3.87326 23.8997 3.70613 23.5655C3.20474 22.5627 2.87048 21.3928 2.87048 20.2228C2.87048 18.6351 3.37187 17.0474 4.37465 15.7939C4.87604 18.2173 6.12953 20.4735 7.96797 22.2284C9.80641 23.9833 11.9791 25.1532 14.4025 25.6546C13.149 26.6574 11.5613 27.2423 9.88997 27.2423C8.88718 27.3259 7.71727 27.0752 6.71449 26.5738Z",
  fill: "url(#paint34_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint30_linear",
  x1: 14.6113,
  y1: 7.68799,
  x2: 14.6113,
  y2: 10.195,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint31_linear",
  x1: 17.1182,
  y1: 11.6157,
  x2: 17.1182,
  y2: 14.1227,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint32_linear",
  x1: 16.3244,
  y1: 15.2925,
  x2: 16.3244,
  y2: 17.7994,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint33_linear",
  x1: 28.4416,
  y1: 8.10596,
  x2: 28.4416,
  y2: 10.6129,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint34_linear",
  x1: 15.3217,
  y1: 0,
  x2: 15.3217,
  y2: 30,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})));

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.ae8e5e98.svg";
export { ForwardRef as ReactComponent };